import { OnboardingProgressStep, PeriodicReviewProgressStep } from '@/context/progress';
import { useIsPeriodicReview } from '@/features/periodic-review/context';

export const useAmlQuestionnaireProgressStep = () =>
  useIsPeriodicReview() ? PeriodicReviewProgressStep.PERIODIC_REVIEW_TRADING_INFORMATION : OnboardingProgressStep.PERSONAL_TRADING_INFORMATION;
